<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      Sviluppato da
      <b-link
        class="ml-25"
        href="https://hyperialab.com"
        target="_blank"
      >Hyperia Lab</b-link>
    </span>

    <span class="float-md-right d-none d-md-block">{{ new Date().getFullYear() }} <b>AMY SUSHI SRL</b> ©
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
